var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropup go-comments-drop files" }, [
    _c(
      "button",
      {
        staticClass: "btn",
        staticStyle: { padding: "0" },
        attrs: {
          disabled: _vm.countFiles(_vm.comment.files) === 0,
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _c("i", { staticClass: "go-icon-20 go-icon-files" }),
        _vm._v(" "),
        _c("em", [_vm._v(_vm._s(_vm.countFiles(_vm.comment.files)))]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dropdown-menu" }, [
      _c("div", { staticClass: "go-panel" }, [
        _c("div", { staticClass: "go-panel-body" }, [
          _c(
            "ul",
            { staticClass: "go-comments-attach files" },
            [
              _vm.comment.files && _vm.countFiles(_vm.comment.files) > 0
                ? [
                    _vm._l(_vm.comment.files, function (file, idx) {
                      return [
                        file.originalName.split(".").includes("pdf") ||
                        file.originalName.split(".").includes("pptx") ||
                        file.originalName.split(".").includes("xlsx") ||
                        file.originalName.split(".").includes("docx")
                          ? _c("li", { key: file.originalName + "-" + idx }, [
                              _c("div", [
                                _c("p", [
                                  file &&
                                  ((file.originalName &&
                                    file.originalName
                                      .split(".")
                                      .includes("pdf")) ||
                                    (file.type && file.type.includes("pdf")))
                                    ? _c("img", {
                                        attrs: {
                                          src: "/content/images/images_v4/common/go-icon-document/file-pdf-fill.svg",
                                          alt: "PDF Icon",
                                        },
                                      })
                                    : file &&
                                      ((file.originalName &&
                                        file.originalName
                                          .split(".")
                                          .includes("docx")) ||
                                        (file.type &&
                                          file.type.includes(".document")))
                                    ? _c("img", {
                                        attrs: {
                                          src: "/content/images/images_v4/common/go-icon-document/file-word-fill.svg",
                                          alt: "Word Icon",
                                        },
                                      })
                                    : file &&
                                      ((file.originalName &&
                                        file.originalName
                                          .split(".")
                                          .includes("xlsx")) ||
                                        (file.type &&
                                          file.type.includes(".sheet")))
                                    ? _c("img", {
                                        attrs: {
                                          src: "/content/images/images_v4/common/go-icon-document/file-excel-fill.svg",
                                          alt: "Excel Icon",
                                        },
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: "/content/images/DOCUMENT.png",
                                          alt: "default",
                                        },
                                      }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: file.storedName,
                                      download: file.originalName,
                                    },
                                  },
                                  [_vm._v(_vm._s(file.originalName))]
                                ),
                                _vm._v(" "),
                                _c("ins", [
                                  _vm._v(
                                    "." +
                                      _vm._s(
                                        file.originalName.split(".")[
                                          file.originalName.split(".").length -
                                            1
                                        ]
                                      )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(_vm._s(_vm.formatSize(file.fileSize))),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }